import { render, staticRenderFns } from "./AddInvoicePage.vue?vue&type=template&id=59ad951e&"
import script from "./AddInvoicePage.vue?vue&type=script&lang=js&"
export * from "./AddInvoicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports